import { render, staticRenderFns } from "./CopyDashboardDrawer.vue?vue&type=template&id=79628448&scoped=true"
import script from "./CopyDashboardDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopyDashboardDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopyDashboardDrawer.vue?vue&type=style&index=0&id=79628448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79628448",
  null
  
)

export default component.exports